import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SiteLayout } from "@/components/site/Layout";
import { useSeo } from "@/context/ContentContext";
import { api, gbp } from "@/lib/api";

export const planLimits = (p) => [
  p.max_practitioners ? `Up to ${p.max_practitioners} practitioners` : "Unlimited practitioners",
  p.max_services ? `Up to ${p.max_services} treatments` : "Unlimited treatments",
  `${p.platform_fee_percent}% platform fee per booking, billed monthly`,
  "Patients pay you directly into your own Stripe",
  ...(p.featured ? ["Featured on the homepage"] : []),
];

export const PlanCard = ({ p, highlight, action }) => (
  <div className={`rounded-[1.5rem] border p-7 flex flex-col lift ${highlight ? "bg-[#1E3A34] text-white border-[#1E3A34]" : "bg-card border-border"}`} data-testid={`plan-card-${p.id}`}>
    <p className="font-display font-bold text-lg">{p.name}</p>
    {p.description && <p className={`text-sm mt-1 ${highlight ? "text-slate-300" : "text-muted-foreground"}`}>{p.description}</p>}
    <p className="mt-5"><span className="font-display text-4xl font-extrabold">{gbp(p.price)}</span><span className={highlight ? "text-slate-300" : "text-muted-foreground"}> /month</span></p>
    <ul className="mt-6 space-y-2.5 text-sm flex-1">
      {[...new Set([...planLimits(p), ...(p.features || [])])].map((f) => (
        <li key={f} className="flex gap-2"><Check className={`h-4 w-4 mt-0.5 shrink-0 ${highlight ? "text-accent" : "text-primary"}`} />{f}</li>
      ))}
    </ul>
    <div className="mt-7">{action}</div>
  </div>
);

export default function Pricing() {
  useSeo("pricing");
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)); }, []);
  return (
    <SiteLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="eyebrow">Pricing</p>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">Simple plans for every clinic</h1>
        <p className="text-muted-foreground mt-3 max-w-xl">Monthly billing, cancel any time. Your clinic is listed on the marketplace while your plan is active.</p>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {plans.map((p, i) => (
            <PlanCard key={p.id} p={p} highlight={i === 1} action={
              <Button className={`w-full rounded-full ${i === 1 ? "bg-accent hover:bg-accent/90" : ""}`} asChild data-testid={`pricing-choose-${p.id}`}>
                <Link to="/for-clinics/signup">Get started</Link>
              </Button>
            } />
          ))}
        </div>
      </section>
    </SiteLayout>
  );
}
